import React from "react";
import { useTranslation } from "react-i18next";

import WPHeading from "../../../../packages/WPHeading";

import SliderCard from "../../../../components/SliderCard";
import { cleaningEffectivenessConfig } from "../AdvancedSettings.config";

import IconWithTooltip from "../../../../common/styles/components/headings/IconWithTooltip";

const CleaningEffectivenessCalculation = ({
  resetKey,
  settings,
  suggestedSettings,
  handleChange,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="info-section">
        <WPHeading fontNoto size="small" className="mt-24">
          {t("advanceSettings.cleaningEffectivenessCalculation")}
        </WPHeading>
        <IconWithTooltip label={t("helpInformation.cleaningEffectivenessCalculationHelp")} />
      </div>
      <div className="slider-cards-group">
        {Object.entries(
          cleaningEffectivenessConfig.cleaningEffectivenessCalculation,
        ).map(([apiKey, config]) => {
          const isRecommended = suggestedSettings[apiKey] != null;
          const minValue = config.isDynamic
            ? parseFloat(settings.min_time) || config.fallbackRanges?.hard?.min
            : config.minValue;
          const maxValue = config.isDynamic
            ? parseFloat(settings.max_time) || config.fallbackRanges?.hard?.max
            : config.maxValue;
          return (
            <div className="slider-card-container" key={apiKey}>
              <SliderCard
                key={`${apiKey}-${resetKey}`}
                min={minValue}
                max={maxValue}
                label={t(`advanceSettings.${config.key}`)}
                isInteger={config.integer}
                inputValue={settings[apiKey] ?? ""}
                recommended={isRecommended ? suggestedSettings[apiKey] : null}
                leftLabel={config.leftLabelKey ? t(`advanceSettings.${config.leftLabelKey}`) : undefined}
                rightLabel={config.rightLabelKey ? t(`advanceSettings.${config.rightLabelKey}`) : undefined}
                onChange={(val) =>
                  handleChange({
                    type: "slider",
                    key: apiKey,
                    value: val,
                    min: minValue,
                    max: maxValue,
                  })
                }
              />
            </div>
          );
        })}
      </div>
    </>
  );
};

export default CleaningEffectivenessCalculation;
